import { Pipe, PipeTransform, inject } from '@angular/core';
import { PaymentStatus } from '../enums';
import { Observable } from 'rxjs';
import { PaymentStatusProviderService } from '../providers';

@Pipe({
  name: 'paymentStatus',
})
export class PaymentStatusPipe implements PipeTransform {
  private readonly provider = inject(PaymentStatusProviderService);

  public transform(status: PaymentStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
